import { AutocompleteRenderOptionState, Box } from '@mui/material';
import { ChipAutocomplete, PoolButton, PoolModal } from '@synergy/components';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import { Contact } from '../../../../common/models/contact';

export interface DemandsTopicContactAssignModalProps {
    availableContacts: Contact[];
    contacts?: Contact[];
    isVisible?: boolean;
    onConfirm: (contacts: Contact[]) => void;
    onCancel: () => void;
}

export const DemandsTopicContactAssignModal = (props: DemandsTopicContactAssignModalProps) => {
    const { contacts: propContacts, availableContacts, isVisible = false, onConfirm, onCancel } = props;
    const [contacts, setContacts] = useState<Contact[]>(propContacts ?? []);

    useEffect(() => {
        setContacts(propContacts ?? []);
    }, [propContacts]);

    const handleConfirm = () => {
        onConfirm(contacts);
        setContacts([]);
    };
    const handleCancel = () => {
        onCancel();
        setContacts([]);
    };

    const renderOption = (contact: Contact, state: AutocompleteRenderOptionState) => {
        const nameMatches = match(contact.fullName, state.inputValue);
        const nameParts = parse(contact.fullName, nameMatches);

        return (
            <Box>
                {nameParts.map((namePart, index) => (
                    <Box component="span" sx={{ color: namePart.highlight ? '#2196F3' : undefined }} key={index}>
                        {namePart.text}
                    </Box>
                ))}
            </Box>
        );
    };

    return (
        <PoolModal
            title={<FormattedMessage id="app.demands.topics.assignContact" />}
            isVisible={isVisible}
            actionChildren={[
                <PoolButton key="1" variant="text" styleType="firstLevel" onClick={handleCancel}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>,
                <PoolButton key="2" styleType="firstLevel" onClick={handleConfirm}>
                    <FormattedMessage id={'app.common.save'} />
                </PoolButton>,
            ]}
            handleClose={handleCancel}
        >
            <ChipAutocomplete
                noOptionsText={<FormattedMessage id="app.common.emptyResult" />}
                options={availableContacts}
                getOptionLabel={contact => contact.fullName}
                renderOption={renderOption}
                getChipLabel={contact => contact.fullName}
                onChange={(_event, values) => setContacts(values)}
                value={contacts}
                textfieldPlaceholder="app.demands.topics.addContact"
                isOptionEqualToValue={(option, value) => option.id === value.id}
                helperText={<FormattedMessage id="app.demands.topics.contactHint" />}
            />
        </PoolModal>
    );
};
